export default {

    "title": "Protocol Role",
    "entityName": "protocol_roles",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
       

        {
            small:true,
            "value": "name",
            "text": "Name",
            "type": "text",
            "validators": [
                "required"
            ],
            table: {
                sortable: true,
                filter: true
            },     
        },

        {
            small:true,
            value: "group_name",
            text: "Group",
            type: "list",
            list:['Site staff', 'Laboratory', 'Other'],
            table: {
                sortable: true,
                filter: true
            },
            validators: [
                "required"
            ]
        },

                
       
        {
            small:true,
            "value": "redcap_map",
            "text": "REDCap map name",
            "type": "text",
            // "validators": [
            //     "required"
            // ],       
            table: {
                sortable: true,
                filter: true
            },
        },

        {
            small:true,
            "value": "safety_map",
            "text": "SafetyDB map name",
            type:"list",
            list: ['Guest', 'CRO Pharmacovigilance'],
            // "validators": [
            //     "required"
            // ],
            table: {
                sortable: true,
                filter: true
            },     
        },

        {
            small:true,
            "value": "ecds_map",
            "text": "eCDS map name",
            type:"list",
            list: ['Site', 'Monitor'],
            // "validators": [
            //     "required"
            // ],
            table: {
                sortable: true,
                filter: true
            },
        },

        // {
        //     small:true,
        //     "value": "logistic_map",
        //     "text": "EMN Logistic map name",
        //     type:"list",
        //     list: ['Site', 'Lab'],
        //     // "validators": [
        //     //     "required"
        //     // ],
        //     table: {
        //         sortable: true,
        //         filter: true
        //     },
        // },

        {
            full : true,
            type: "textarea", 
            "value": "description",
            "text": "Description",
            "validators": [
                "required"
            ]         
        },

       
        
          
    ],
    "actions": [
        //{ "value": "edit", "text": "Edit", "icon": "mdi-pencil", "color": "primary" },
        "upsert", "remove", "audit_trail"
        // { "value": "export", "text": "Export", "icon": "mdi-microsoft-excel", "color": "primary" }
    ]
}